/* eslint-disable @typescript-eslint/consistent-type-assertions */
export enum pagination {
  PAGE_COUNT_LIST = <any>[
    { label: 1, value: 1 },
    { label: 10, value: 10 },
    { label: 20, value: 20 },
    { label: 50, value: 50 },
  ],
}
